import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ defaultFormData: { moduleId: parameter } });
  //Tab组件里, sectionComponent.child.current 是对应的渲染分选组件
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  sectionComponent.setState({ componentDefaultValue });

  sectionComponent.child.map((child, i) => {
    if (child.current != null) {
      child.current?.setState({ searchParameter: { moduleId: parameter }, moduleId: parameter });
      child.current?.child.current?.setState({ moduleId: parameter });
      setTimeout(() => {
        child.current?.getSectionDataByDefault();
      }, config.setTimeoutMilliSecond);
    }
  })
}

export function manageApprovalConditionTemplateFolder({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.map((child, i) => {
    if (child.current != null && child.current?.child.current?.props.sectionName === 'ApprovalConditionTemplate') {
      child.current?.child.current?.setState({ manageFolderShow: true });
      setTimeout(() => {
        child.current?.child.current?.manageFolder.current?.getApprovalConditionTemplateFolderList();
      }, config.setTimeoutMilliSecond);
    }
  })
}

export function addApprovalConditionTemplate({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Create' });
   httpClient
        .get('Admin/ApprovalConditionTemplateFolder/GetSelectOptionList?moduleId=' + sectionComponent.state.moduleId)
        .then(({ data }) => {
          if (data.result) {
            if (data.data.length > 0) {
              sectionComponent.customForm.current?.setState({ componentDataSource: { ApprovalConditionTemplateFolderId: data.data } });
            }
          } else {
            globalFunction.handleResultError(data, pageComponent);
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error,pageComponent);
        });
  setTimeout(() => {
    let formData = parameter;
    let folderSelectedKeys = sectionComponent.customForm.current?.formRef.current?.getFieldValue();
    sectionComponent.customForm.current?.formRef.current?.setFieldsValue(formData);
    sectionComponent.customForm.current?.setState({ formData });
  }, config.setTimeoutMilliSecond);
}

export function collapseFolder({ component, key } = {}) {
  let data = component.state.data.map((folder, i) => {
    if (folder.key === key) {
      if (folder.Collapsed !== true) {
        folder.Collapsed = true;
      } else {
        folder.Collapsed = false;
      }
    }
    return folder;
  });
  component.setState({ data });
}

//收起所有folder
export function collapseAllFolders({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.map((child, i) => {
    if (child.current != null && child.current?.child.current?.props.sectionName === 'ApprovalConditionTemplate') {
      let data = child.current?.child.current?.state.data.map((folder, i) => {
        folder.Collapsed = true;
        return folder;
      });
      child.current?.child.current?.setState({ data });
    }
  })
}
